import { NgModule } from "@angular/core";
import {
  mapToCanActivateChild,
  PreloadAllModules,
  RouterModule,
  Routes,
} from "@angular/router";

import { RoutingPath } from "@core/enums/routing-path";
import { AuthGuard } from "@core/guards/auth.guard";

const routes: Routes = [
  {
    path: RoutingPath.Login,
    loadChildren: (): any =>
      import("./views/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "",
    loadChildren: (): any =>
      import("./views/wrapper.module").then((m) => m.WrapperModule),
    canActivateChild: mapToCanActivateChild([AuthGuard]),
  },
  {
    path: "**",
    redirectTo: RoutingPath.NotFound,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
